import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _Number$isFinite from '@babel/runtime-corejs3/core-js-stable/number/is-finite';
import _Number$isNaN from '@babel/runtime-corejs3/core-js-stable/number/is-nan';
import { c as clsx } from '../clsx.m-7e9a4a81.js';
import React__default from 'react';
import { T as Typography } from '../Typography-b5ab7944.js';
import '@babel/runtime-corejs3/helpers/typeof';
import '@babel/runtime-corejs3/core-js-stable/array/is-array';
import '@babel/runtime-corejs3/core-js-stable/object/keys';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import '@babel/runtime-corejs3/core-js-stable/instance/filter';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import '@babel/runtime-corejs3/core-js-stable/object/define-property';
import '@babel/runtime-corejs3/helpers/defineProperty';
import '@babel/runtime-corejs3/helpers/objectWithoutProperties';

var Text = Typography.Text;

function priceFormat(price) {
  return price.toFixed(2).toString().replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
}

var Price = function Price(_ref) {
  var label = _ref.label,
      value = _ref.value,
      size = _ref.size;

  if (typeof value !== 'number' || !_Number$isFinite(value) || _Number$isNaN(value)) {
    return null;
  }

  var _priceFormat$split = priceFormat(value).split('.'),
      _priceFormat$split2 = _slicedToArray(_priceFormat$split, 2),
      a = _priceFormat$split2[0],
      _priceFormat$split2$ = _priceFormat$split2[1],
      b = _priceFormat$split2$ === void 0 ? '00' : _priceFormat$split2$;

  return /*#__PURE__*/React__default.createElement("div", {
    className: clsx('smb-price', "smb-price--".concat(size))
  }, label ? /*#__PURE__*/React__default.createElement(Text, {
    preset: "description",
    color: "black",
    className: "smb-price__label"
  }, label) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "smb-price__inner"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "smb-price__dollars"
  }, a), /*#__PURE__*/React__default.createElement("span", {
    className: "smb-price__cents"
  }, b)));
};

export default Price;
